<template>
  <div class="app-container">
    <list ref="list">
      <!-- <template slot="column">
        <el-table-column label="1-22天" align="center" width="160">
          <el-table-column label="金额"></el-table-column>
          <el-table-column label="比率"></el-table-column>
        </el-table-column>
        <el-table-column label="23-33天" align="center" width="160">
          <el-table-column label="金额"></el-table-column>
          <el-table-column label="比率"></el-table-column>
        </el-table-column>
        <el-table-column label="33天以上" align="center" width="160">
          <el-table-column label="金额"></el-table-column>
          <el-table-column label="比率"></el-table-column>
        </el-table-column>
      </template> -->
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/agingreceivable/list";
// import editDialog from "@/components/finance/dealings/otherdeal/editDialog";

export default {
  name: "agingreceivable",
  mixins: [curdMixins],
  components: {
    list,
  },

  methods: {
    // path:"/business/purchase/emptor"
    create() {
      this.$refs.editDialog.openCreate();
      // this.$router.push({name:'editEmptor'})
    },
    edit() {
      this.$refs.editDialog.openEdit();
      // this.$router.push({name:'editEmptor'})
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PropertyId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>